import { kbConfluenceContextResource } from '@jira/router-resources__confluence-context/src/kbConfluenceContextResource.tsx';
import { getServicedeskPageContextResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const getReportsWithKbResources = (): RouteResource<any>[] => [
	...getServicedeskPageContextResources(),
	kbConfluenceContextResource,
];
